import React from "react";
import { useTranslation } from "react-i18next";
import "./LoadincScreen.css";

const LoadingScreen = () => {

  const [t] = useTranslation();

  return (
    <div className="fixed top-0 left-0 right-0 bottom-0 w-full h-screen z-50 overflow-hidden bg-gray-700 opacity-50 flex flex-col items-center justify-center">
      <div className="loader ease-linear rounded-full border-5 border-t-2 border-gray-400 h-12 w-12 mb-4"></div>
      <h2 className="text-center text-white text-xl font-semibold">
        {t('loading')}
      </h2>
      <p className="w-1/3 text-center text-white">
        {t('loading info')}        
      </p>
    </div>
  );
};

export default LoadingScreen;
